import GoodsTracking from "@/pages/cd/GoodsTracking"
import GoodsTrackingMap from "@/pages/cd/GoodsTrackingMap"
import Index from "@/pages/cd/Index"
import Search from "@/pages/cd/Search"
import Th from "@/pages/cd/th/Index"
import ThOrder from "@/pages/cd/th/Order"
import ThGoods from "@/pages/cd/th/Goods"
import ThTrans from "@/pages/cd/th/Trans"
import ThFiles from "@/pages/cd/th/Files"
import Sh from "@/pages/cd/sh/Index"
import ShOrder from "@/pages/cd/sh/Order"
import ShGoods from "@/pages/cd/sh/Goods"
import ShTrans from "@/pages/cd/sh/Trans"
import ShFiles from "@/pages/cd/sh/Files"
import Thd from "@/pages/cd/Thd"
import Psd from "@/pages/cd/Psd"
import Abnormal from "@/pages/cd/Abnormal"

let router = [{
    path: "/cd/goods_tracking",
    name: "goods_tracking",
    component: GoodsTracking,
    meta: {
      title: "货物跟踪",
      keepAlive: true,
      login: false // 是否需要登录
    }
  }, {
    path: "/cd/tracking_map",
    name: "tracking_map",
    component: GoodsTrackingMap,
    meta: {
      title: "运输轨迹",
      keepAlive: true,
      login: false // 是否需要登录
    }
  }, {
    path: "/cd/",
    name: "Index",
    component: Index,
    meta: {
      title: "TMS运输管理系统",
      keepAlive: true
    }
  }, {
    path: "/cd/thd",
    name: "thd",
    component: Thd,
    meta: {
      title: "提货单",
      role: [0]
    }
  }, {
    path: "/cd/psd",
    name: "psd",
    component: Psd,
    meta: {
      title: "送货单",
      role: [0]
    }
  }, {
    path: "/cd/search",
    name: "search",
    component: Search,
    meta: {
      title: "搜索"
    }
  }, {
    path: "/cd/th",
    name: "th",
    component: Th,
    meta: {
      title: "提货单"
    },
    children: [{
      path: "/cd/th/order",
      name: "order",
      component: ThOrder,
      meta: {
        title: "提货单信息"
      },
    }, {
      path: "/cd/th/goods",
      name: "goods",
      component: ThGoods,
      meta: {
        title: "货物"
      },
    }, {
      path: "/cd/th/trans",
      name: "trans",
      component: ThTrans,
      meta: {
        title: "物流"
      },
    }, {
      path: "/cd/th/files",
      name: "files",
      component: ThFiles,
      meta: {
        title: "回单"
      },
    }]
  }, {
    path: "/cd/sh",
    name: "sh",
    component: Sh,
    meta: {
      title: "送货单"
    },
    children: [{
      path: "/cd/sh/order",
      name: "order",
      component: ShOrder,
      meta: {
        title: "送货单信息"
      },
    }, {
      path: "/cd/sh/goods",
      name: "goods",
      component: ShGoods,
      meta: {
        title: "货物"
      },
    }, {
      path: "/cd/sh/trans",
      name: "trans",
      component: ShTrans,
      meta: {
        title: "物流"
      },
    }, {
      path: "/cd/sh/files",
      name: "files",
      component: ShFiles,
      meta: {
        title: "回单"
      },
    }]
  },
  {
    path: "/cd/abnormal",
    name: "abnormal",
    component: Abnormal,
    meta: {
      title: "异常反馈",
      role: [0]
    }
  }
];
export default router;



// WEBPACK FOOTER //
// ./src/router/cd.js